import styled from "styled-components"

export const TokenImageContainer = styled.img`
  display: inline-block;
  min-width: 32px;
  max-width: 32px;
  height: 32px;
  vertical-align: middle;
  border-radius: 10px;
  margin-right: 10px;
  object-fit: cover;
`

export const TokenVideoContainer = styled.video`
  display: inline-block;
  min-width: 32px;
  max-width: 32px;
  height: 32px;
  border-radius: 10px;
  vertical-align: middle;
  margin-right: 10px;
  object-fit: cover;
`